const emptyObject = Object.freeze({});

export default emptyObject;
